import React from "react";
import Container from "../../components/container/Container";
import { Col, Row } from "antd";
import SimpleCardBrand from "../../components/simpleCard/SimpleCard";
import Title from "../../components/typography/title/Title";

const ProductListingBrand = ({ data,selectedCategoryName  }) => {
  console.log(data);
  return (
    <div className="productListing">
      <Container>
        <Row className="page-header">
          <Col className="title-section" md={24}>
            <Title size={"41"} weight={700} tag={"h1"}>
            {selectedCategoryName} {/* Dynamic category name */}

            </Title>
            <Title
              customClass={"sub-title"}
              size={"21"}
              weight={500}
              tag={"h5"}
            >
              Customize Your {selectedCategoryName} Make it uniquely yours
             
            </Title>
          </Col>
        </Row>
        <Row gutter={[20, 20]}>
          {data.map((item, index) => {
            return (
              <Col xs={12} md={4} lg={4} xl={4}  key={index}>
                <SimpleCardBrand data={item} cardType={"categoryCard"} />
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};

export default ProductListingBrand;
